// src/components/ui/notifications/notification.tsx
import * as React from 'react'
import { Alert, AlertTitle, Snackbar } from '@mui/material'

export type NotificationProps = {
  notification: {
    id: string
    type: 'info' | 'success' | 'warning' | 'error'
    title: string
    message?: string
  }
  onDismiss: (id: string) => void
}

export const Notification = ({
  notification: { id, type, title, message },
  onDismiss,
}: NotificationProps) => {
  const [open, setOpen] = React.useState(true)

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    // clickawayでは閉じないようにする（通知は明示的に閉じるか自動消去のみ）
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  const handleExited = () => {
    // Snackbarが完全に消えた後にonDismissを呼ぶ
    onDismiss(id)
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000} // 3秒で自動消去
      onClose={handleClose}
      TransitionProps={{
        onExited: handleExited, // アニメーション完了後の処理
      }}
      sx={{
        position: 'relative', // 固定位置ではなく相対位置
        transform: 'none !important', // Snackbarのデフォルト位置調整を無効化
        left: 'auto !important',
        right: 'auto !important',
        top: 'auto !important',
        bottom: 'auto !important',
      }}>
      <Alert
        severity={type}
        variant='standard'
        onClose={handleClose}
        role='alert'
        aria-label={title}
        sx={{
          maxWidth: '360px',
          width: '100%',
          boxShadow: (theme) => theme.shadows[4],
          '& .MuiAlert-message': {
            flex: 1,
            minWidth: 0,
          },
        }}>
        <AlertTitle sx={{ fontWeight: 'medium', mb: message ? 0.5 : 0 }}>{title}</AlertTitle>
        {message && message}
      </Alert>
    </Snackbar>
  )
}
